<template>
  <div id="main-content">
    <article>
          <div class="breadcrumb">
      <a href="/">Accueil</a> >
      <a href="/produits">Produits</a> 
  
    </div>
      <div class="entry-content">
        <h2><strong>Top Star</strong></h2>
        <div>
          <ul class="et_pb_tabs_controls clearfix">
            <li v-for="(tab, index) in tabs" :key="index" @click="activeTab = index" :class="{'et_pb_tab_active': activeTab === index}">
              <a href="#">{{ tab.name }}</a>
            </li>
          </ul>
          <div v-for="(tab, index) in tabs" :key="index" v-show="activeTab === index">
            <p>{{ tab.content }}</p>
            <img :src="tab.image" :alt="'Image de ' + tab.name">
              <!-- Bouton pour télécharger la fiche technique PDF -->
            <a :href="tab.pdf" download :title="'Télécharger la fiche technique de ' + tab.name" class="download-btn">
              Télécharger la fiche technique
            </a>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import TopStar75Orange from '@/assets/topstar.png';
import TopStar50Orange from '@/assets/topstar.png';
import TopStar75Citron from '@/assets/topstar.png';
import TopStar50Citron from '@/assets/topstar.png';


export default {
  name: 'TopstarI',
  data() {
    return {
      activeTab: 0,
tabs: [
  { name: 'Top Star 75 Orange', content: 'Chaque bouteille de 200ml contient 75g de glucose', image: TopStar75Orange, pdf: '/BROCHURE GLUCOSE TOPSTAR.pdf' },
  { name: 'Top Star 50 Orange', content: 'Chaque bouteille de 200ml contient 50g de glucose', image: TopStar50Orange, pdf: '/BROCHURE GLUCOSE TOPSTAR.pdf' },
  { name: 'Top Star 75 Citron', content: 'Chaque bouteille de 200ml contient 75g de glucose', image: TopStar75Citron, pdf: '/BROCHURE GLUCOSE TOPSTAR.pdf' },
  { name: 'Top Star 50 Citron', content: 'Chaque bouteille de 200ml contient 50g de glucose', image: TopStar50Citron, pdf: '/BROCHURE GLUCOSE TOPSTAR.pdf' }
]

    };
  }
};
</script>

<style scoped>
/* ======== MODE CLAIR PAR DÉFAUT ======== */

.breadcrumb {
  font-size: 10px;
  color: #888;
  margin-top: 0px;
  padding: 10px 320px;
}

.breadcrumb a {
  color: #1c1c1d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #0056b3;
}

.entry-content {
  padding: 40px;
  background-color: #ffffff;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  max-width: 800px;
  margin: auto;
  margin-top: 1px;
}

.entry-content h2 {
  text-align: center;
  font-size: 2.2em;
  color: #34495e;
  margin-bottom: 20px;
}

/* Onglets */
.et_pb_tabs_controls {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
}

.et_pb_tabs_controls li {
  cursor: pointer;
  padding: 2px 30px;
  margin: 0 5px;
  border-radius: 8px;
  background-color: #ecf0f1;
  transition: background-color 0.3s ease, color 0.3s ease;
  color: #34495e;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);
}

.et_pb_tabs_controls li:hover,
.et_pb_tabs_controls .et_pb_tab_active {
  background-color: #00998B;
  color: #ffffff;
  font-weight: 600;
}

.et_pb_tabs_controls li a {
  text-decoration: none;
  color: inherit;
}

/* Contenu des onglets */
.entry-content div[v-show] {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  opacity: 0;
  animation: fadeIn 0.4s ease forwards;
  animation-delay: 0.2s;
}

.entry-content p {
  font-size: 1.1em;
  color: #7f8c8d;
  line-height: 1.6;
  margin: 15px 0 20px;
}

/* Image */
.entry-content img {
  max-width: 75%;
  height: auto;
  margin: 10px 0;
  border-radius: 12px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
}

/* Bouton de téléchargement */
.download-btn {
  display: inline-block;
  margin-top: 20px;
  padding: 12px 30px;
  font-size: 1em;
  color: #1b1a1a;
  background-color: #eaeeef;
  text-decoration: none;
  border-radius: 3px;
  transition: background-color 0.3s ease, transform 0.2s ease;
  box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);
}

.download-btn:hover {
  background-color: #00998B;
  transform: translateY(-2px);
  color: white;
}

/* Animation */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Responsive */
@media (max-width: 768px) {
  .breadcrumb {
    font-size: 0.6em;
    padding: 8px;
  }

  .entry-content {
    padding: 20px;
  }

  .entry-content h2 {
    font-size: 1.8em;
  }

  .et_pb_tabs_controls li {
    padding: 10px 15px;
    font-size: 1em;
  }

  .entry-content img {
    max-width: 90%;
  }

  .download-btn {
    padding: 10px 20px;
    font-size: 0.9em;
  }
}

@media (max-width: 480px) {
  .entry-content h2 {
    font-size: 1.6em;
  }

  .et_pb_tabs_controls {
    flex-direction: column;
    align-items: center;
  }

  .et_pb_tabs_controls li {
    width: 100%;
    text-align: center;
    padding: 10px;
    font-size: 0.9em;
    margin: 5px 0;
  }

  .entry-content p {
    font-size: 1em;
  }

  .download-btn {
    padding: 8px 16px;
    font-size: 0.85em;
    width: 100%;
    text-align: center;
  }
}

/* ======== 🌙 MODE SOMBRE AUTOMATIQUE ======== */
@media (prefers-color-scheme: dark) {
  body, .entry-content {
    background-color: #0b0f14;
    color: #e6edf1;
  }

  .breadcrumb {
    color: #aaa;
  }

  .breadcrumb a {
    color: #73d8cf;
  }

  .breadcrumb a:hover {
    color: #00bfa5;
  }

  .entry-content {
    background-color: #10151c;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.6);
  }

  .entry-content h2 {
    color: #73d8cf;
  }

  .et_pb_tabs_controls li {
    background-color: #142231;
    color: #e6edf1;
    border: 1px solid rgba(255, 255, 255, 0.08);
  }

  .et_pb_tabs_controls li:hover,
  .et_pb_tabs_controls .et_pb_tab_active {
    background-color: #00998B;
    color: white;
  }

  .entry-content p {
    color: #d1d5db;
  }

  .entry-content img {
    box-shadow: 0 5px 10px rgba(255, 255, 255, 0.05);
  }

  .download-btn {
    background-color: #142231;
    color: #e6edf1;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  }

  .download-btn:hover {
    background-color: #00998B;
    color: white;
  }
}
</style>

